import React from 'react'
import InfoHint from '../../../../../common/InfoHint'
import { v2ReasonLabel } from '../../DepositPayoutTimeline/core/consts'
import { nf } from '../core/consts'
import { METRIC_HINTS } from '../core/hints'
import { V2Admissions, V2Block as V2BlockData } from '../core/types'

type Props = {
  block: V2BlockData
  currency: string
}

const refusedTotal = (refused: Record<string, number>) =>
  Object.values(refused).reduce((sum, n) => sum + n, 0)

/** Причины отказа по убыванию: самая частая — первой. */
const RefusedList: React.FC<{ refused: Record<string, number> }> = ({ refused }) => {
  const rows = Object.entries(refused).sort((a, b) => b[1] - a[1])
  if (rows.length === 0) return <span className='text-muted'>отказов нет</span>
  return (
    <div className='d-flex flex-column gap-1'>
      {rows.map(([code, n]) => (
        <div key={code} className='d-flex justify-content-between gap-3'>
          <span className='text-muted'>{v2ReasonLabel(code)}</span>
          <span className='fw-semibold'>{nf.format(n)}</span>
        </div>
      ))}
    </div>
  )
}

const AdmissionsColumn: React.FC<{ title: string; a: V2Admissions }> = ({ title, a }) => (
  <div className='col-12 col-md-4'>
    <div className='fw-bold mb-2'>{title}</div>
    <div className='d-flex gap-4 mb-2'>
      <div>
        <div className='fs-3 fw-bold'>{nf.format(a.admitted)}</div>
        <div className='text-muted fs-8'>принято · из них с растяжкой {nf.format(a.stretched)}</div>
      </div>
      <div>
        <div className='fs-3 fw-bold'>{nf.format(refusedTotal(a.refused))}</div>
        <div className='text-muted fs-8'>не принято</div>
      </div>
    </div>
    <RefusedList refused={a.refused} />
  </div>
)

/** Раздел дашборда второго контура: решения по выплатам и депозитам и ползунки ядра. */
const V2Block: React.FC<Props> = ({ block, currency }) => {
  const d = block.deposits_1h
  const dials = block.dials
  return (
    <div className='card h-100'>
      <div className='card-header'>
        <h3 className='card-title d-inline-flex align-items-center'>
          Второй контур ({currency})
          <InfoHint text={METRIC_HINTS.v2_block} />
        </h3>
      </div>
      <div className='card-body fs-7'>
        <div className='row g-5 mb-5'>
          <AdmissionsColumn title='Выплаты за час' a={block.admissions_1h} />
          <AdmissionsColumn title='Выплаты за сутки' a={block.admissions_24h} />
          <div className='col-12 col-md-4'>
            <div className='fw-bold mb-2'>Депозиты за час</div>
            <div className='d-flex flex-wrap gap-4 mb-2'>
              <div>
                <div className='fs-3 fw-bold'>{nf.format(d.issued)}</div>
                <div className='text-muted fs-8'>выдан реквизит</div>
              </div>
              <div>
                <div className='fs-3 fw-bold'>{nf.format(d.offered)}</div>
                <div className='text-muted fs-8'>плитки · выбрано {nf.format(d.tiles_committed)}</div>
              </div>
              <div>
                <div className='fs-3 fw-bold'>{nf.format(refusedTotal(d.refused))}</div>
                <div className='text-muted fs-8'>отказ</div>
              </div>
            </div>
            <RefusedList refused={d.refused} />
          </div>
        </div>
        <div className='border-top pt-3 d-flex flex-wrap gap-4 text-muted fs-8'>
          <span>Приём: {dials.admit}</span>
          <span>Растяжка: {nf.format(dials.stretch_min)} мин</span>
          <span>Штраф SLA: {dials.sla}</span>
          <span>Доведение: {dials.finish}</span>
          <span>
            Коридор суммы: −{nf.format(dials.flex_down)} / +{nf.format(dials.flex_up)}
          </span>
          <span>Плиток: {dials.max_tiles}</span>
        </div>
      </div>
    </div>
  )
}

export default V2Block
